export default "__VITE_ASSET__66e2bf57__"